/*
 * Widerrufsbutton — Stufenlogik fuer templates/page.widerruf.liquid
 *
 * Grundsaetze, die hier bewusst durchgehalten werden:
 *  - Es wird ausschliesslich das FORMAT geprueft. Keine Bestellpruefung,
 *    keine Ablehnung wegen falscher Bestellnummer oder Datenmismatch.
 *  - Der Request geht erst beim Klick auf "Widerruf bestaetigen" raus
 *    (Zweistufigkeit ist Pflicht).
 *  - Scheitert der Request technisch, ist der Widerruf NICHT zugegangen.
 *    Dann wird kein Erfolg behauptet, sondern Stufe 2 bleibt stehen mit
 *    Fehlermeldung und Wiederholmoeglichkeit.
 *  - Der Teilwiderruf ist ein Freitextfeld. Bewusst kein Abgleich gegen die
 *    Bestellung: das haette einen offenen Endpunkt gebraucht, ueber den sich
 *    die Zuordnung Bestellnummer => Kunde durchprobieren liesse. Leeres Feld
 *    bedeutet Vollwiderruf.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rxk-widerruf]');
  if (!root) return;

  var i18nNode = root.querySelector('[data-rxk-widerruf-i18n]');
  if (!i18nNode) return;

  var i18n;
  try {
    i18n = JSON.parse(i18nNode.textContent);
  } catch (e) {
    return;
  }

  var endpoint = root.dataset.endpoint;
  var locale = root.dataset.locale || 'de';

  var form = root.querySelector('[data-rxk-form]');
  var stages = {
    form: root.querySelector('[data-stage="form"]'),
    confirm: root.querySelector('[data-stage="confirm"]'),
    success: root.querySelector('[data-stage="success"]')
  };
  if (!form || !stages.form || !stages.confirm || !stages.success) return;

  var fields = {
    name: form.elements.name,
    order: form.elements.order,
    email: form.elements.email,
    reason: form.elements.reason,
    items: form.elements.items
  };

  var confirmBtn = root.querySelector('[data-rxk-confirm]');
  var backBtn = root.querySelector('[data-rxk-back]');
  var timestampEl = root.querySelector('[data-rxk-timestamp]');
  var emailNoteEl = root.querySelector('[data-rxk-email-note]');

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var payload = null;

  /* ---------- Stufenwechsel ---------- */

  function showStage(name) {
    Object.keys(stages).forEach(function (key) {
      stages[key].hidden = key !== name;
    });

    var heading = stages[name].querySelector('.rxk-widerruf__stage-heading');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Formatvalidierung ---------- */

  function setError(key, message) {
    var el = root.querySelector('[data-error-for="' + key + '"]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    if (fields[key]) {
      fields[key].setAttribute('aria-invalid', message ? 'true' : 'false');
    }
  }

  function validate() {
    var checks = [
      ['name', fields.name.value.trim() !== '', i18n.err_name],
      ['order', fields.order.value.trim() !== '', i18n.err_order],
      ['email', EMAIL_RE.test(fields.email.value.trim()), i18n.err_email]
    ];

    var firstBad = null;
    checks.forEach(function (check) {
      var key = check[0];
      var valid = check[1];
      setError(key, valid ? '' : check[2]);
      if (!valid && !firstBad) firstBad = fields[key];
    });

    if (firstBad) firstBad.focus();
    return !firstBad;
  }

  /* ---------- Stufe 1 -> Stufe 2 ---------- */

  function setSummary(key, value) {
    var el = root.querySelector('[data-summary="' + key + '"]');
    if (el) el.textContent = value;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!validate()) return;

    var itemsText = fields.items ? fields.items.value.trim() : '';

    payload = {
      name: fields.name.value.trim(),
      order_number: fields.order.value.trim(),
      email: fields.email.value.trim(),
      reason: fields.reason ? fields.reason.value.trim() : '',
      items_text: itemsText,
      scope: itemsText ? 'partial' : 'full',
      locale: locale,
      source: 'shopify-widerruf-button'
    };

    setSummary('name', payload.name);
    setSummary('order', payload.order_number);
    setSummary('email', payload.email);
    setSummary('reason', payload.reason || i18n.reason_none);
    setSummary('items', itemsText || i18n.items_all);

    setError('send', '');
    showStage('confirm');
  });

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      showStage('form');
    });
  }

  /* ---------- Stufe 2 -> Stufe 3 ---------- */

  function showSuccess(receivedAt) {
    var stamp = receivedAt ? new Date(receivedAt) : new Date();
    if (isNaN(stamp.getTime())) stamp = new Date();

    /*
     * Muss zeichengleich zur Bestaetigungsmail sein — es ist derselbe
     * Zeitpunkt, und zwei verschiedene Darstellungen davon verunsichern.
     *
     * 'en' allein liefert US-Format (9/5/2026). Die Mail formatiert en-GB,
     * also hier ebenso.
     *
     * Fest auf Europe/Berlin, wieder wie die Mail: massgeblich ist der
     * Zugang bei uns, nicht die Uhr des Kunden. Ohne das saehe ein Kunde in
     * New York auf der Seite eine andere Uhrzeit als in seiner Mail.
     * timeZoneName macht das sichtbar, statt es zu verschweigen.
     */
    /*
     * Bis hierher gab es nur Deutsch und Englisch, und alles Unbekannte fiel
     * auf de-DE. Bei einer dritten Sprache war das falsch: ein japanischer
     * Kunde bekaeme ein deutsches Datumsformat.
     * Bekannte Sprachen sauber zuordnen, alles andere auf en-GB — die
     * internationale Fassung, nicht die deutsche.
     */
    var dateLocales = { de: 'de-DE', en: 'en-GB', fr: 'fr-FR', es: 'es-ES' };
    var dateLocale = dateLocales[String(locale).slice(0, 2).toLowerCase()] || 'en-GB';
    var formatted = stamp.toLocaleString(dateLocale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Berlin',
      timeZoneName: 'short'
    });

    if (timestampEl) {
      timestampEl.textContent = i18n.received_at.replace('%{timestamp}', formatted);
    }
    if (emailNoteEl) {
      emailNoteEl.textContent = i18n.email_note.replace('%{email}', payload.email);
    }

    showStage('success');
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (!payload) return;

      confirmBtn.disabled = true;
      confirmBtn.textContent = i18n.sending;
      setError('send', '');

      var body = Object.assign({}, payload, { declared_at: new Date().toISOString() });

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json().catch(function () {
            return null;
          });
        })
        .then(function (data) {
          showSuccess(data && data.received_at);
        })
        .catch(function () {
          // Nicht uebermittelt heisst nicht zugegangen — hier wird kein Eingang behauptet.
          confirmBtn.disabled = false;
          confirmBtn.textContent = i18n.retry;
          setError('send', i18n.err_send);
        });
    });
  }

})();
